import { useIntl } from '@/intl'
import { FilterOption } from '@/scopes/search/types'
import { space } from '@sunwebgroup/ui-components'
import { isEmpty } from 'ramda'
import * as React from 'react'
import { styled } from 'styled-components'
import { DropdownMultiselect, useEditableDropdownMultiselect } from '../DropdownMultiselect'
import { FormField, FormFieldControl, FormFieldLabel } from '../FormField'

const FocusPadding = styled.div`
  padding: ${space('primitives_space_12')};
`

export function ArrivalAirportFilterComponent({
  onValueChange,
  options,
  selectedValues,
  onEditFinish,
  disabled,
}: {
  onValueChange: (newSelectedValues: string[]) => void
  options: FilterOption<string, object>[]
  selectedValues: string[]
  onEditFinish: (selection: string[]) => void
  disabled?: boolean | undefined
}) {
  const intl = useIntl()

  const multiselectDropdownProps = useEditableDropdownMultiselect({
    value: selectedValues,
    onValueChange,
    onEditFinish,
  })

  if (isEmpty(options)) {
    return null
  }

  return (
    <FormField as="div">
      <FormFieldLabel>{intl.formatMessage({ id: 'search_filter_arrival_airport_label' })}</FormFieldLabel>
      <FormFieldControl data-qa="arrival-airport-filter">
        <DropdownMultiselect.Root
          disabled={disabled}
          placeholder={intl.formatMessage({ id: 'search_filter_arrival_airport_placeholder' })}
          {...multiselectDropdownProps}
        >
          <DropdownMultiselect.Selection>
            {options.map(({ value, name }) => (
              <DropdownMultiselect.SelectedValue key={value} value={value}>
                {name}
              </DropdownMultiselect.SelectedValue>
            ))}
          </DropdownMultiselect.Selection>
          <DropdownMultiselect.Popover
            title={intl.formatMessage({ id: 'search_filter_arrival_airport_label' })}
            closeText={intl.formatMessage({ id: 'close' })}
          >
            <FocusPadding>
              {options.map(({ value, name, resultsCount }) => (
                <DropdownMultiselect.CheckboxWithCounterOption key={value} value={value} count={resultsCount}>
                  {name}
                </DropdownMultiselect.CheckboxWithCounterOption>
              ))}
            </FocusPadding>
            <DropdownMultiselect.ConfirmButton>
              {intl.formatMessage({ id: 'destination_filter_confirm_button' })}
            </DropdownMultiselect.ConfirmButton>
          </DropdownMultiselect.Popover>
        </DropdownMultiselect.Root>
      </FormFieldControl>
    </FormField>
  )
}
